// PT · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "Novidades do WA Checkin",
  "kicker": "Novidades",
  "stepOf": "Passo {n} de {total}",
  "close": "Fechar",
  "dontShow": "Não mostrar novamente",
  "prev": "Anterior",
  "next": "Seguinte",
  "done": "Entendido",
  "steps": {
    "icons": {
      "title": "Ícones nas suas reservas",
      "text": "Cada reserva do calendário e da lista mostra agora pequenos ícones: pedidos à Receção IA, chamadas, notas e se ainda falta dinheiro por cobrar. Passe o rato por cima para ver o detalhe sem abrir a reserva.",
      "cta": ""
    },
    "early": {
      "title": "Cobre a entrada antecipada",
      "text": "O early check-in já pode ter preço. O agente IA pergunta a hora de chegada, calcula o custo e envia o link de pagamento. Quando é pago, fica confirmado automaticamente.",
      "cta": "Configurar no Agente IA"
    },
    "reception": {
      "title": "Receção IA",
      "text": "Tudo o que os hóspedes pedem ao agente (entrar mais cedo, sair mais tarde, mais noites, faturas, recados de chamadas) chega a uma única caixa. Aprove, recuse ou dê prioridade com um clique e veja o valor do que é cobrado.",
      "cta": "Abrir Receção IA"
    },
    "translate": {
      "title": "Tradução em tempo real",
      "text": "No chat de cada reserva e na caixa de entrada, ative a tradução: o que o hóspede escreve chega-lhe no seu idioma e, ao premir Enter, vê primeiro a sua mensagem traduzida para o idioma dele antes de a enviar.",
      "cta": "Ir para mensagens"
    },
    "voice": {
      "title": "Chamadas com o agente de voz",
      "text": "Ative a receção telefónica: o agente IA atende as chamadas no idioma de quem liga, esclarece dúvidas, envia o link de reserva e deixa-lhe um resumo de cada chamada.",
      "cta": "Ativar as chamadas"
    }
  },
  "demo": {
    "iconsTipTitle": "Receção IA",
    "iconsTipEarly": "Early check-in",
    "iconsTipPending": "Pendente:",
    "paid": "Paga",
    "earlyGuest": "Podemos entrar às 11:00?",
    "earlyAgent": "Sim! A entrada às 11:00 custa 30 €. Pode pagar aqui:",
    "earlyPaid": "Paga · confirmada",
    "rx": {
      "early": "Early check-in",
      "late": "Late checkout",
      "extend": "Prolongar estadia"
    },
    "pending": "Pendente",
    "confirmed": "Confirmada",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "A que horas podemos levantar as chaves?",
    "trMine": "A partir das 15:00, esperamos por vocês",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Resumo da chamada",
    "voiceSummary": "Perguntou pelo estacionamento e reservou 2 noites. Link de reserva enviado por WhatsApp."
  }
};
